import React from 'react';
import { Clock, ThumbsUp, ShieldCheck, BrainCircuit, Zap, Calculator } from 'lucide-react';
export const BenefitsSection = () => {
  const benefits = [{
    icon: <Clock className="h-10 w-10 text-blue-600 mb-4" data-id="element-29" />,
    title: 'Spart wertvolle Zeit',
    description: 'Reduziere deinen Buchhaltungsaufwand um bis zu 80% durch automatische Belegzuordnung und Kategorisierung.'
  }, {
    icon: <ThumbsUp className="h-10 w-10 text-blue-600 mb-4" data-id="element-30" />,
    title: 'Weniger Rückfragen',
    description: 'Vollständige und korrekte Belege bedeuten weniger Nachfragen von deinem Steuerberater.'
  }, {
    icon: <ShieldCheck className="h-10 w-10 text-blue-600 mb-4" data-id="element-31" />,
    title: 'DSGVO-konform & sicher',
    description: 'Deine Daten werden verschlüsselt und DSGVO-konform in Deutschland gespeichert.'
  }, {
    icon: <BrainCircuit className="h-10 w-10 text-blue-600 mb-4" data-id="element-32" />,
    title: 'Intelligente KI',
    description: 'Unsere KI lernt mit jeder Zuordnung und wird immer besser darin, deine Belege zu erkennen.'
  }, {
    icon: <Zap className="h-10 w-10 text-blue-600 mb-4" data-id="element-33" />,
    title: 'Sofort einsatzbereit',
    description: 'Intuitive Benutzeroberfläche – keine lange Einarbeitung oder Schulung notwendig.'
  }, {
    icon: <Calculator className="h-10 w-10 text-blue-600 mb-4" data-id="element-34" />,
    title: 'Kosteneffizient',
    description: 'Spare Geld durch reduzierte Bearbeitungszeiten und weniger Fehler in der Buchhaltung.'
  }];
  return <section id="benefits" className="w-full bg-white py-16 md:py-24" data-id="element-35">
      <div className="container mx-auto px-4" data-id="element-36">
        <div className="text-center mb-12" data-id="element-37">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-38">
            Warum TaxTidy?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-39">
            Mach Schluss mit dem Buchhaltungsstress und genieße diese Vorteile:
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 max-w-5xl mx-auto" data-id="element-40">
          {benefits.map((benefit, index) => <div key={index} className="text-center" data-id="element-41">
              <div className="flex justify-center" data-id="element-42">{benefit.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-43">
                {benefit.title}
              </h3>
              <p className="text-gray-600" data-id="element-44">{benefit.description}</p>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-45">
          <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-46">
            Bereit für eine stressfreie Buchhaltung?
          </h3>
          <button className="bg-blue-600 text-white px-8 py-3 rounded-md hover:bg-blue-700 transition font-medium text-lg" data-id="element-47">
            Kostenlos starten
          </button>
          <p className="mt-4 text-gray-600" data-id="element-48">
            Keine Kreditkarte erforderlich. 14 Tage kostenlos testen.
          </p>
        </div>
      </div>
    </section>;
};